import React from 'react';

const BlocksFill = (props) => (
  <svg
    width={20}
    height={11}
    viewBox="0 0 20 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 7C20 8.10457 19.1046 9 18 9H12.1553C11.9749 9.24299 11.7682 9.47192 11.5352 9.68164C10.5975 10.5255 9.32606 11 8 11C6.67394 11 5.40252 10.5255 4.46484 9.68164C4.23182 9.47192 4.02511 9.24299 3.84473 9H2C0.895431 9 0 8.10457 0 7V2C0 0.895431 0.895431 1.61064e-08 2 0H5.06152C5.09977 0.156041 5.15506 0.30926 5.22852 0.457031C5.37928 0.760219 5.60043 1.03551 5.87891 1.26758C6.15738 1.49963 6.48776 1.68394 6.85156 1.80957C7.21554 1.93521 7.60603 2 8 2C8.39397 2 8.78446 1.93521 9.14844 1.80957C9.51224 1.68394 9.84262 1.49963 10.1211 1.26758C10.3996 1.03551 10.6207 0.760219 10.7715 0.457031C10.8449 0.30926 10.9002 0.156041 10.9385 0H18C19.1046 0 20 0.895431 20 2V7Z"
      fill="white"
    />
  </svg>
);

export default BlocksFill;